"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSeparator = exports.StyledWrapper = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../utils/styleConsts");

var wrapperStyles = function wrapperStyles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flexWrap:wrap;alignItems:center;")
  );
};

var StyledWrapper = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-nqd2sy0"
})(wrapperStyles));
exports.StyledWrapper = StyledWrapper;

var separatorStyles = function separatorStyles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:", _styleConsts.font.size.large, ";padding:0px 8px;")
  );
};

var StyledSeparator = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-nqd2sy1"
})(separatorStyles));
exports.StyledSeparator = StyledSeparator;